import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from 'app/pages/users/users.service';
import { VehiclesService } from 'app/pages/vehicles/vehicles.service';
import { DriverScheduleService } from '../../driver-schedule.service';
import { DriversService } from 'app/pages/drivers/drivers.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
declare const moment: any;

@Component({
  selector: 'app-create-schedule',
  templateUrl: './create-schedule.component.html',
  styleUrls: ['./create-schedule.component.scss']
})
export class CreateScheduleComponent implements OnInit {

  @Input('schedule') schedule;
  @Input('selectedDate') selectedDate;
  @Input('selectedProvider') selectedProvider?;
  @Output() reload = new EventEmitter<any> ();

  scheduleForm: FormGroup;
  vehicles = [];
  providers = [];
  isLoadingData = false;
  private driverInfo;

  timeMask = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
  pattern = new RegExp(/(0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9]){1}/);

  constructor(
    private fb: FormBuilder,
    private userService: UsersService,
    private vehicleService: VehiclesService,
    private service: DriverScheduleService,
    private driverService: DriversService,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    this.scheduleForm = this.fb.group({
      vehicleid: ['', Validators.required],
      sheduleid: '',
      starttime: ['', this.validatorsTime],
      endtime: ['', this.validatorsTime],
      driverid: '',
      date: ''
    });

  }

  get validatorsTime() {
   return [Validators.required, Validators.pattern(new RegExp(this.pattern))];
  }

  ngOnInit() {
    if (this.schedule) {
      this.scheduleForm.patchValue(this.schedule);
      this.onChangeVehicle(this.schedule.vehicleid);
      this.getDriverInfo();
    }

    // this.getVehicles(); Este ya no se llama
    this.callService();
    this.getProviders();
  }

  /**
   * this save the schedule
   */
  saveSchedule() {
    if (this.isValidPtoDate()) {
      if (this.isValidDay()) {
        if (this.isValidTimes()) {
          this.service.updateSchedule(this.scheduleForm.getRawValue()).subscribe(
            res => {
              this.toastrAlertHelper.success(res.message);
              this.reload.emit();
            }, error => {
              this.showError(error.message);
            }
          );
        } else {
          this.showError(this.getTimeErrorMessage());
        }
      } else {
        this.showError('This driver is not elegible this day');
      }
    } else {
      this.showError('This driver is not elegible this date');
    }
  }

  /**
   * this get all providers
   */
  private getProviders() {
    this.userService.getAllProviders().subscribe(
      data => {
        this.providers = data;
      }
    );
  }

  /**
   * this retrieve driver info from backend
   */
  private getDriverInfo() {
    const driverid = this.scheduleForm.get('driverid').value;
    this.isLoadingData = true;
    this.driverService.getDriversMCT(driverid).finally(() => {
      this.isLoadingData = false;
    })
    .subscribe(
      info => {
        this.driverInfo = info;
      }
    );
  }

  /**
   * this validate start and end times
   */
  private isValidTimes() {
    if (this.scheduleForm.get('vehicleid').value == 0) {
      return true;
    }
    const formStartTime = this.scheduleForm.get('starttime').value;
    const formEndTime = this.scheduleForm.get('endtime').value;
    return moment(formStartTime, 'HH:mm').isSameOrBefore(moment(formEndTime, 'HH:mm:ss'));
  }

  getTimeErrorMessage() {
    if (this.driverInfo) {
     return 'The start time cannot be greater than the end time!';
    } else {
      return 'Start and End fields invalid';
    }
  }

  /**
   * this validate if the selected driver is elegible these day
   */
  private isValidDay() {
    if (this.driverInfo) {
      if (this.getScheduleDate()) {
        const date = this.getScheduleDate();
        const dayString = date.format('dddd').toLowerCase();
        return this.driverInfo[dayString];
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /**
   * this validate paid time off
   */
  private isValidPtoDate() {
    if (this.driverInfo && this.getScheduleDate()) {
      const ptoStart = this.driverInfo.ptofromdateformat;
      const ptoEnd = this.driverInfo.ptoenddateformat;
      if (ptoStart && ptoEnd) {
       return !this.getScheduleDate().isBetween(ptoStart, ptoEnd);
      }
    }

    return true;
  }

  /**
   * this return schedule date string
   */
  private getScheduleDate() {
    if (!this.selectedDate) {
      return null;
    }

    const split = this.selectedDate.split(' - ');
    if (split.length > 1) {
      return moment(split[1], 'MM-DD-YY');
    } else {
      return null;
    }
  }

  /**
   * this show alert with an error
   */
  showError(message) {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Error!',
      text: message,
      type: 'error'
    });
  }


  /**
   * @description this method loads all the vehicles
   */
  callService() {
    this.isLoadingData = true;
    this.vehicleService.getVehicles(0, '', false, false, this.selectedProvider, '').subscribe(
        data => {
          this.isLoadingData = false;
          this.vehicles = data;
        });

  }

  /**
   * this execute when user change vehicle
   * @param event vehicle id
   */
  onChangeVehicle(event) {
    if (event != 0) {
      this.scheduleForm.get('starttime').setValidators(this.validatorsTime);
      this.scheduleForm.get('endtime').setValidators(this.validatorsTime);
      this.scheduleForm.get('starttime').enable();
      this.scheduleForm.get('endtime').enable();
    } else {
      this.scheduleForm.patchValue({
        starttime: '',
        endtime: ''
      });
      this.scheduleForm.get('starttime').clearValidators();
      this.scheduleForm.get('endtime').clearValidators();
      this.scheduleForm.get('starttime').disable();
      this.scheduleForm.get('endtime').disable();
    }

    this.scheduleForm.get('starttime').updateValueAndValidity();
    this.scheduleForm.get('endtime').updateValueAndValidity();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/driver-schedule/components/create-schedule/create-schedule.component.ts